import { render, staticRenderFns } from "./DrippingMetalPendant.vue?vue&type=template&id=3925442f&scoped=true&"
import script from "./DrippingMetalPendant.vue?vue&type=script&lang=js&"
export * from "./DrippingMetalPendant.vue?vue&type=script&lang=js&"
import style0 from "./DrippingMetalPendant.vue?vue&type=style&index=0&id=3925442f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3925442f",
  null
  
)

component.options.__file = "DrippingMetalPendant.vue"
export default component.exports